import React from "react";
import { Users, Home, Megaphone, BarChart3, FileCheck, Smartphone, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "CRM Omnichannel",
  description: "Acompanhe a jornada de compra e fidelize clientes com régua de relacionamento automatizada e personalizada.",
  icon: Users
}, {
  title: "Estoque Unificado",
  description: "Controle total de mercadorias em tempo real, integrando estoques de lojas físicas e centros de distribuição.",
  icon: Home
}, {
  title: "Motor de Promoções",
  description: "Crie ofertas dinâmicas, campanhas de cashback e cupons para aumentar a recorrência de compra no seu varejo.",
  icon: Megaphone
}, {
  title: "Business Intelligence",
  description: "Visualize KPIs críticos e tome decisões estratégicas baseadas em dados com dashboards dinâmicos e intuitivos.",
  icon: BarChart3
}, {
  title: "Checkout Moderno",
  description: "Finalize vendas com rapidez e segurança total, oferecendo múltiplas opções de pagamento e agilidade no PDV.",
  icon: FileCheck
}, {
  title: "Gestão Mobile",
  description: "Monitore o desempenho das suas lojas e aprove transferências de onde estiver diretamente pelo seu smartphone.",
  icon: Smartphone
}];
export default function OnePlatformCompleteControl() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="30868" id="detalhes-das-funcionalidades" ref={ref} className={`py-20 transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6 tracking-tight">
            Funcionalidades que Transformam seu Negócio
          </h2>
          <p className="text-xl text-foreground/80">
            Ferramentas robustas e intuitivas desenvolvidas para escalar a operação do seu varejo com eficiência operacional e inteligência de dados.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, i) => <div key={i} data-index={i} className="h-full">
              <Card className="h-full border border-white/10 rounded-[12px] bg-card shadow-2xl shadow-black/50 hover:shadow-primary/20 transition-all duration-300 hover:-translate-y-[5px] hover:border-b-2 hover:border-b-primary group">
                <CardHeader>
                  <div className="mb-4 inline-flex items-center justify-center w-12 h-12 rounded-lg bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                    <feature.icon className="w-6 h-6" />
                  </div>
                  <CardTitle className="text-2xl font-bold text-foreground">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base text-foreground/70 leading-relaxed">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>

        <div className="mt-16 text-center">
          <Button asChild size="lg" className="text-lg px-8 h-12 rounded-[10px] bg-primary hover:bg-primary/90 text-primary-foreground shadow-lg shadow-primary/20">
            <Link to="/ContactsPage">Solicitar demonstração</Link>
          </Button>
        </div>
      </div>
    </section>;
}